import { RadioButtonGroup } from 'Components/FormField/RadioButtonGroup/RadioButtonGroup';
import { UnansweredQuestionMarker } from 'Components/RequiresAttentionMarker/UnansweredQuestionMarker';
import { Text, TextProps } from 'Components/Text/Text';
import { IrqQuestionSingleSelect, IrqQuestionType } from 'Models/InherentRisk';

interface QuestionSingleSelectProps {
    formFieldLabelId: string;
    onAnswerChanged: (answerIndex?: number) => void;
    question: IrqQuestionSingleSelect;
    questionNumber: number;
    showUnansweredQuestionMarker: boolean;

    disabled?: boolean;
    questionTextVariant?: TextProps['variant'];
}

/**
 * Renders a question that requires the user to select a single choice.
 * Currently used only for the IRQ.
 */
export const QuestionSingleSelect = (props: QuestionSingleSelectProps) => {
    return (
        <>
            <Text variant={props.questionTextVariant ?? 'Text2'}>{`${props.questionNumber}. ${props.question.text}`}</Text>
            {props.showUnansweredQuestionMarker && <UnansweredQuestionMarker questionIsRequired questionType={IrqQuestionType.SINGLE_SELECT} />}
            <RadioButtonGroup
                clearable
                formFieldLabel="Answer"
                disabled={props.disabled}
                formFieldLabelId={props.formFieldLabelId}
                onChange={props.onAnswerChanged}
                options={props.question.options.map((option, index) => ({
                    label: option.text,
                    value: index,
                }))}
                defaultValue={props.question.answer}
            />
        </>
    );
};
